const tokens = {
  KKOGTOKEN: '0xFe712Ebe45bf3203b031d0520CDc6228b4e75e8E',
  CLAIM: '0x31D921d7357e062c27d7a15caF23aedD09996dd1',
};
export default tokens;

